module.exports = __webpack_public_path__ + "img/pb3.b4bb7666.png";